'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var clsx_m = require('../node_modules/clsx/dist/clsx.m.js');
var styles = require('@material-ui/styles');
var ListItem = require('@material-ui/core/ListItem');
var ListItemText = require('@material-ui/core/ListItemText');
var Typography = require('@material-ui/core/Typography');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var ListItem__default = /*#__PURE__*/_interopDefaultLegacy(ListItem);
var ListItemText__default = /*#__PURE__*/_interopDefaultLegacy(ListItemText);
var Typography__default = /*#__PURE__*/_interopDefaultLegacy(Typography);

var _excluded = ["title", "icon", "action", "disablePadding"];
var useStyles = styles.makeStyles({
  root: {
    paddingBottom: props => props.disablePadding ? 4 : 12,
    // Adds a margin to match the list's default padding-bottom.
    marginBottom: props => props.disablePadding ? 0 : 8,
    overflow: 'hidden',
    alignItems: 'center'
  },
  icon: {
    fontSize: 28,
    marginRight: 8
  },
  title: {
    fontSize: 18,
    fontWeight: 700
  }
});
var ListTitle = _ref => {
  var {
    title,
    icon: iconFromProps,
    action,
    disablePadding = false
  } = _ref,
      listItemProps = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var classes = useStyles({
    disablePadding
  });
  var icon = iconFromProps ? /*#__PURE__*/React__namespace.cloneElement(iconFromProps, {
    className: classes.icon
  }) : null;
  return /*#__PURE__*/React__namespace.createElement(ListItem__default['default'], _rollupPluginBabelHelpers['extends']({}, listItemProps, {
    className: clsx_m(classes.root, listItemProps === null || listItemProps === void 0 ? void 0 : listItemProps.className)
  }), icon, /*#__PURE__*/React__namespace.createElement(ListItemText__default['default'], null, /*#__PURE__*/React__namespace.createElement(Typography__default['default'], {
    className: classes.title
  }, title)), action);
};
ListTitle.propTypes = {
  /** Placeholder for action components. */
  action: index.node,

  /**
   * If `false` the padding on the bottom is increased to match the default
   * `List` padding.
   */
  disablePadding: index.bool,

  /** Optional icon node. */
  icon: index.node,

  /** Title of the component. */
  title: index.string
};

exports.ListTitle = ListTitle;
exports.default = ListTitle;
